/**
 * Arvis Frontend Logger
 * 
 * Bu yardımcı, uygulamanın verbose loglarını yönetir.
 * REACT_APP_LOG_ON ayarı aktifse konsola detaylı bilgi yazdırır.
 */
import clientConfig from '../helpers/clientConfig';

const isEnabled = clientConfig.REACT_APP_LOG_ON;

const logger = {
    info: (message, ...args) => {
        if (isEnabled) {
            console.log(`%c[INFO] ${new Date().toLocaleTimeString()} - ${message}`, 'color: #007bff; font-weight: bold;', ...args);
        }
    },
    debug: (message, ...args) => {
        if (isEnabled || clientConfig.REACT_APP_ENV === 'development') {
            console.debug(`%c[DEBUG] ${new Date().toLocaleTimeString()} - ${message}`, 'color: #6c757d;', ...args);
        }
    },
    warn: (message, ...args) => {
        console.warn(`[WARN] ${new Date().toLocaleTimeString()} - ${message}`, ...args);
    },
    error: (message, error, ...args) => {
        console.error(`%c[ERROR] ${new Date().toLocaleTimeString()} - ${message}`, 'color: #dc3545; font-weight: bold;', error, ...args);
    },
    trace: (message, ...args) => {
        if (isEnabled) {
            console.groupCollapsed(`%c[TRACE] ${message}`, 'color: #17a2b8;');
            console.trace(...args);
            console.groupEnd();
        }
    }
};

export default logger;
